import { Box } from '@mui/material'
import React, { useEffect, useMemo, useState } from 'react'
import ChartHeader from './ChartHeader'
import ChartBox from './ChartBox'
import TripBookingDetails from '../TripBookingDetails'
import { createOldChartData } from '../../../../utils/helpers'
import { chartDataObj, seatDefaultObj } from '../../constant'
import ZoomControl from '../../../../common/ZoomControl'
import { useDispatch, useSelector } from 'react-redux'
import { getAPIGetPickupsDropoffsBBT, getBookingDetailsToPrintAgents, getBookingsLoad } from '../../../../redux/Booking/BookingActions'
import { showErrorAlert, updateLoadingScreen } from '../../../../redux/Actions'
import TicketDetails from '../../../modal/TicketSearch/TicketDetails'
import ModifyBookingModal from '../../../modal/ModifyBooking/ModifyBookingModal'
import { useLoadTripDetails } from '../../../../hook/useLoadTripDetails'
import moment from 'moment'
import dayjs from 'dayjs'

const TripChart = (props) => {
    const { bkgDeatails, filterOpt, selectedSeat, setSelectedSeat,
        showLogoHeader = false,
        handleResetTripData = () => { },
        setBkgDetails = () => { },
        setFilterOpt = () => { }
    } = props;
    const dispatch = useDispatch();
    const store = useSelector((store) => store);
    const { loadTripDetails } = useLoadTripDetails();

    const { user } = store;
    const { userDetails } = user;
    const [chartData, setChartData] = useState(chartDataObj);
    const [chartScale, setChartScale] = useState(
        () => JSON.parse(localStorage.getItem('chartScale')) || 1
    )
    const [openModal, setOpenModal] = useState({
        open: false,
        id: 0,
        data: {}
    })
    const fetchChartLaylout = useMemo(() => {
        return createOldChartData(filterOpt?.chartData || [])
    }, [filterOpt?.chartData])
    useEffect(() => {
        setChartData((prev) => ({
            ...prev,
            ...fetchChartLaylout
        }))
    }, [fetchChartLaylout])

    const handleSelectedSeat = (obj) => {
        if (obj.IsAvailable === 1 && obj.IsAisle !== 1) {
            let oldData = selectedSeat
            let alreadySeat = oldData.filter((item) => item.SeatLabel === obj.SeatLabel)
            if (alreadySeat.length !== 0) {
                let onlyOneSeatData = oldData.length === 1 ? { ...oldData?.[0] } : {}
                let newData = oldData.filter((item) => item.SeatLabel !== obj.SeatLabel)
                setSelectedSeat(newData.length === 0 ? [{
                    ...seatDefaultObj,
                    name: onlyOneSeatData?.name || '',
                    age: onlyOneSeatData?.age || '',
                }] : newData)
            } else {
                let emptySeat = oldData.filter((item) => item.SeatLabel?.toString()?.trim() === '')
                if (emptySeat.length !== 0) {
                    let fillSeat = false
                    let newData = oldData.map((item) => {
                        if (item.SeatLabel?.toString()?.trim() === '' && !fillSeat) {
                            fillSeat = true
                            return {
                                ...item, ...obj,
                                baseFare: bkgDeatails?.seatFareIsDiscount ? obj.disBaseFare : obj.baseFare
                            }
                        }
                        return item
                    })
                    setSelectedSeat(newData)
                } else {
                    setSelectedSeat((prev) => ([
                        ...prev,
                        {
                            ...seatDefaultObj, ...obj,
                            baseFare: bkgDeatails?.seatFareIsDiscount ? obj.disBaseFare : obj.baseFare
                        }
                    ]))
                }
            }
        }
    }


    const handleSeatModDetails = (open = false, id = 0, seatObj = {}) => {
        if (id === 2 || id === 1 || id === 3 || id === 7) {
            const body = {
                intUserID: 0,
                strSearchType: "P",
                intBookingID: seatObj.BookingID,
                strSeatNo: "",
                intTripID: 0,
                dtJourneyDate: '0001-01-01',
                intFromCityId: 0,
                intToCityID: 0,
                intAgentUserID: userDetails?.AgentUserID || 0,
                strContactNo: "",
                strPassengerEmailID: '',
                strTicketNo: '',
            }
            dispatch(getBookingsLoad(body, id === 7)).then((res) => {
                if (res.data.status) {
                    let parseData = JSON.parse(res.data.Data)
                    if (parseData?.Table.length !== 0 && parseData?.Table1.length !== 0) {
                        if (id === 7) {
                            let bkgPNRDetails = parseData?.Table?.[0] || {}
                            const pickUpAndDropOffBody = {
                                strRouteCode: `${bkgPNRDetails?.ServiceID}~${bkgPNRDetails?.TripID}~${bkgPNRDetails?.FromCityID}~${bkgPNRDetails?.ToCityID}~${moment(bkgPNRDetails?.ChartDate).format('YYYY-MM-DD')}`,
                                intAgentID: userDetails?.AgentID || 0,
                            }
                            dispatch(getAPIGetPickupsDropoffsBBT(pickUpAndDropOffBody)).then((pickUpRes) => {
                                if (pickUpRes?.data?.status) {
                                    const pickUp = ((pickUpRes?.data?.Data?.Table || []).map((obj) => ({ ...obj, label: `${dayjs(obj.Pickup_Time, 'YYYY-MM-DD hh:mm:ss A').format('DD-MMM-YYYY hh:mm A')} | ${obj.Pickup_Name} ${(obj.pickupCharge_per !== 0 || obj.pickupCharge_rs !== 0) ? obj.pickupCharge_per !== 0 ? ` | Extra Per Seat ${obj.pickupCharge_per}%` : `| Extra Per Seat Rs. ${obj.pickupCharge_rs}` : ''}` }))).sort((a, b) => dayjs(a.Pickup_Time, 'YYYY-MM-DD hh:mm:ss A') - dayjs(b.Pickup_Time, 'YYYY-MM-DD hh:mm:ss A'));
                                    const dropOff = ((pickUpRes?.data?.Data?.Table1 || []).map((obj) => ({ ...obj, label: `${dayjs(obj.Dropoff_Time, 'YYYY-MM-DD hh:mm:ss A').format('DD-MMM-YYYY hh:mm A')} | ${obj.Dropoff_Name} ${(obj.dropoffCharge_rs !== 0 || obj.dropoffCharge_per !== 0) ? obj.dropoffCharge_per !== 0 ? `| Extra Per Seat ${obj.dropoffCharge_per}%` : `| Extra Per Seat Rs. ${obj.dropoffCharge_rs}` : ''}` }))).sort((a, b) => dayjs(a.Dropoff_Time, 'YYYY-MM-DD hh:mm:ss A') - dayjs(b.Dropoff_Time, 'YYYY-MM-DD hh:mm:ss A'));
                                    handleModal(open, id, {
                                        ...parseData,
                                        pickUpList: pickUp || [],
                                        dropOffList: dropOff || [],
                                    })
                                } else {
                                    dispatch(showErrorAlert(pickUpRes?.data?.Message || ''))
                                }
                            })

                        } else {
                            handleModal(open, id, { ...parseData, cancelRole: id === 2 || id === 3 ? 1 : 0, confirmRole: id === 1 ? 1 : 0 })
                        }
                    } else {
                        dispatch(updateLoadingScreen(false))
                        dispatch(showErrorAlert('No Found data'))
                    }
                } else {
                    dispatch(updateLoadingScreen(false))
                    dispatch(showErrorAlert(res.data.Message || ''))
                }
            })
        } else if (id === 4) {
            const printBody = {
                intBookingID: seatObj.BookingID,
                intBranchID: 0,
                intUserID: userDetails?.AgentUserID || 0
            }
            dispatch(getBookingDetailsToPrintAgents(printBody)).then((res) => {
                if (res.data?.status) {
                    let ticketFormatID = JSON.parse(res.data?.Data || "{}")?.Table?.[0]?.TicketFormatID || 0
                    if (ticketFormatID === 0) {
                        window.open(`http://bookbustickets.com/PrintTicket_Agent.aspx?bkgID=${seatObj.BookingID}&pnr=${seatObj.BookingID}&uid=${userDetails.AgentUserID}&utype=A`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes')
                    } else {
                        window.open(`http://bookbustickets.com/PrintTicket_Format.aspx?bkgID=${seatObj.BookingID}&pnr=${seatObj.BookingID}&ticketFormatID=${ticketFormatID}`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes')
                    }
                } else {
                    dispatch(showErrorAlert(res.data?.Message))
                }
            })
        } else if (id === 6) {
            navigator.clipboard.writeText(seatObj?.BookingID)
        }

        else if (id === 5) {
            const message = `
            Dear *${seatObj?.PaxName}* Your ${seatObj.BkgType === 'AC' ? 'Confirm' : seatObj.BkgType === 'AP' ? 'phone' : ''} booking is done in ${bkgDeatails?.tripDetails?.CompanyName},
            ✅        Booking PNR: ${seatObj?.BookingID}
            ✅        Journey Route:${seatObj?.RouteName}
            ✅        Journey Date: ${seatObj?.JDate}
            ✅        Bus Number: ${bkgDeatails?.tripDetails?.BusMasterNumber || 'NA'}
            ✅        Seats Booked: ${seatObj?.Seatcount}
            ✅        Seat Numbers: ${seatObj?.AllSeats}
            ✅        Pickup Point: ${seatObj?.PickupName}, ${seatObj?.PickupDate}
            ✅        DropOff Point: ${seatObj?.DropoffName}
            `;
            const url = `https://web.whatsapp.com/send?phone=91${seatObj.PassengerContactNo1}&text=${encodeURIComponent(message)}`;
            window.open(url, '_blank')
        }

    }

    const handleModal = (open = false, id = 0, data = {}) => {
        setOpenModal((prev) => ({
            ...prev,
            open: open,
            id: id,
            data: data
        }))
    }
    const handleZoomIn = () => {
        let newScale = Math.min(chartScale + 0.1, 2)
        setChartScale(newScale)
        localStorage.setItem('chartScale', newScale)
    };
    const handleZoomOut = () => {
        let newScale = Math.min(chartScale - 0.1, 2)
        setChartScale(newScale)
        localStorage.setItem('chartScale', newScale)
    };

    const handleResetTrip = (trip) => {
        handleResetTripData()
        loadTripDetails({ tripDetails: trip, setBkgDetails, setFilterOpt, setSelectedSeat, deleteCache: true });
    }
    return (
        <>
            <Box className='tripChart_page' sx={{ height: showLogoHeader ? `calc(100vh - 44px - 71px)` : `calc(100vh - 65px)` }}>
                <Box sx={{ flexShrink: 0 }}>
                    <ChartHeader chartData={{ ...chartData, }} />
                </Box>
                {Object.keys(chartData?.seatRowData)?.length > 0 &&
                    <Box sx={{ position: 'relative' }} >
                        <ZoomControl handleZoomIn={handleZoomIn} handleZoomOut={handleZoomOut} />
                    </Box>
                }
                <Box sx={{ flex: 1, minHeight: '200px', overflow: 'auto', borderBottom: '1px solid #0000001A', backgroundColor: '#fff' }}>
                    <ChartBox bkgDeatails={bkgDeatails} chartData={chartData} chartScale={chartScale} selectedSeat={selectedSeat} handleSelectedSeat={handleSelectedSeat} handleSeatModDetails={handleSeatModDetails} />
                </Box>
                <Box sx={{
                    flexShrink: 0, backgroundColor: '#fff',
                }}>
                    <TripBookingDetails bkgDeatails={bkgDeatails} />
                </Box>
            </Box>
            {openModal.open &&
                <>
                    {(openModal.id === 2 || openModal.id === 1 || openModal.id === 3) &&
                        <TicketDetails id={openModal?.id} open={openModal.id === 2 || openModal.id === 1 || openModal.id === 3} titleText={'Ticket Details'} onClose={handleModal}
                            data={openModal.data}
                            handleResetTrip={() => {
                                handleResetTrip(bkgDeatails.tripDetails || {})
                            }}
                            bkgDeatails={bkgDeatails}
                            filterOpt={filterOpt}
                        />
                    }
                    {openModal.id === 7 &&
                        <ModifyBookingModal
                            open={openModal.open && openModal.id === 7}
                            titleText="Modify Booking"
                            onClose={() => {
                                handleModal()
                            }}
                            data={openModal.data}
                            bkgDeatails={bkgDeatails}
                            handleResetTrip={() => {
                                handleModal()
                                handleResetTrip(bkgDeatails.tripDetails || {})
                            }}
                        />
                    }
                </>
            }
        </>
    )
}

export default TripChart